/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HotToastService } from '@ngneat/hot-toast';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { EditorOptions } from '../text-editor/text-editor.interface';

@Component({
  selector: 'app-new-category',
  templateUrl: './new-category.component.html',
  styleUrls: ['./new-category.component.scss']
})
export class NewCategoryComponent implements OnInit {

  moduleName: Module = 'JOB';
  enableDuration: boolean = true;
  customColors: string[] = [];
  formGroup: UntypedFormGroup;
  selectedCustomColor: string;
  textEditorOptions: EditorOptions = {
    editorId:'categoryDescription',
    attachmentType: 'JOB_NOTE',
    module:'JOB',
    isForm: true,
    showTemplate: false
  };
  constructor(
    private _jobService: JobsService,
    private _dataCollectorService: DataCollectorService,
    private _toast: HotToastService,
    public matDialogRef: MatDialogRef<NewCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public utilityService: UtilityService
  ) { }

  closeModal(): void {
    this.matDialogRef.close();
  }

  saveCategory(): void {
    this.formGroup.markAllAsTouched();
    if(this.formGroup.status === 'INVALID'){
      return;
    }
    const payload = {
      'category': {
        'category_name': this.formGroup.get('name').value,
        'category_description': this.formGroup.get('description').value,
        'estimated_duration': {
          'hours': this.formGroup.get('hours').value || 0,
          'minutes': this.formGroup.get('minutes').value || 0,
          'days': this.formGroup.get('days').value
        },
        'category_color': this.formGroup.get('color').value
      }
    };

    if (this.moduleName === 'NON_JOB_EVENT') {
      delete payload['category']['estimated_duration'];
      payload['category']['is_available'] = !this.formGroup.get('markAsBusy').value ?? true;
      const nonJobEventCategoryUrl: string = `${this._dataCollectorService.baseurl()}/non_job_events/category`;
      this._dataCollectorService.postData(nonJobEventCategoryUrl, payload).subscribe(
        (res: any) => {
          payload.category['category_uid'] = res?.data?.category_uid;
          this.matDialogRef.close(payload);
        });
    }
    else {
      this._dataCollectorService.postData(this._jobService.getCategoryUrl(), payload).subscribe(
        (res: any) => {
          payload.category['category_uid'] = res?.data?.category_uid;
          this.matDialogRef.close(payload);
        },
        (err: any) => {
        }
      );
    }
  }

  selectCustomColor(color: string): void {
    this.selectedCustomColor = color;
    this.formGroup.get('color').setValue(color);
  }

  getDurationError(name: string): string {
    if(this.formGroup.controls[name].hasError('max') || this.formGroup.controls[name].hasError('min')){
      if(name === 'hours'){
        return this.utilityService.getLocaleValue('customer.error.sla.hours');
      }else if(name === 'minutes'){
        return this.utilityService.getLocaleValue('customer.error.sla.minutes');
      }else if (name === 'days'){
        return this.utilityService.getLocaleValue('customer.error.sla.days');
      }
    }
    else if(this.formGroup.controls[name].hasError('onlyInteger')) {
      return this.utilityService.getLocaleValue('customer.error.number.days');
    }
  }

  getDurationRequiredError(): string {
    if(
      (this.formGroup.controls['days'].touched && this.formGroup.controls['days'].hasError('required')) ||
      (this.formGroup.controls['hours'].touched && this.formGroup.controls['hours'].hasError('required')) ||
      (this.formGroup.controls['minutes'].touched && this.formGroup.controls['minutes'].hasError('required'))
    ){
      return this.utilityService.getLocaleValue('text.field_is_required');
    }
  }

  // Custom validator function to check if the value is a integer number
  onlyIntegerValidator(control: UntypedFormControl): any {
    const value = control.value;
    if (value % 1 !== 0) {
      return { 'onlyInteger': true };
    }
    return null;
  }

  ngOnInit(): void {
    this.formGroup = new UntypedFormGroup({
      'name': new UntypedFormControl('', Validators.required),
      'color': new UntypedFormControl('#000000'),
      'days': new UntypedFormControl('', [Validators.required, Validators.min(0), this.onlyIntegerValidator]),
      'hours': new UntypedFormControl(0, [Validators.min(0), Validators.max(23)]),
      'minutes': new UntypedFormControl(0, [Validators.min(0), Validators.max(59)]),
      'description': new UntypedFormControl(''),
      'markAsBusy': new UntypedFormControl(false)
    });
    this.moduleName = this.data?.data?.moduleName;
    this.customColors = this.data?.data?.customColors;
    this.enableDuration = this.moduleName !== 'NON_JOB_EVENT';
    if (this.customColors?.length) {
      this.selectedCustomColor = this.customColors[0];
      this.selectCustomColor(this.selectedCustomColor);
    }
    if (this.moduleName === 'NON_JOB_EVENT') {
      this.formGroup.get('days').clearValidators();
    }
  }

}

type Module = 'JOB' | 'NON_JOB_EVENT';
